<template>
  <!-- 公告信息主页 -->
  <div>
    <navigation-bar></navigation-bar>
    <div class="main">
      <el-row>
        <!-- 左侧导航栏 -->
        <el-col :span="4">
          <div class="sidebar">
            <div class="sidebar_title">公告信息</div>
            <div class="sidebar_item" :class='{ active: index===number}' v-for="(item,index) in noticeTypeList" :key="index" @click="change(index)">
              {{item.name}}
            </div>
          </div>
        </el-col>
        <!-- 内容 -->
        <el-col :span="16">
          <div class="content">
            <div class="banner">
              <img src="../../../assets/console/ggxx/banner.png" alt="">
            </div>
            <div class="con_main">
              <div class="notice_item" v-for="(item,index) in noticeInfoList" :key="index">
                <div class="item_left" @click="enterNoticeDetail(item)">
                  <div class="item_title">{{item.title}}</div>
                  <div class="item_content">{{item.summary}}</div>
                </div>
                <div class="item_right">
                  <div class="date" v-text="item.publishTime.substr(5,5).replace('-','.')"></div>
                  <div class="dash">一</div>
                  <div class="year" v-text="item.publishTime.substr(0,4)"></div>
                </div>
              </div>
            </div>
            <!-- 分页 -->
            <div class="pagination">
              <el-pagination
                align="center"
                @current-change="handleCurrentChange"
                :current-page.sync="nowPage"
                :page-size="5"
                background
                layout="prev, pager, next"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { queryAllNotificationType, queryNotificationByConditions } from '@/api/console/noticeInfo.js'
import NavigationBar from '../../../components/console/navigationBar.vue'
export default {
  components: {
    NavigationBar
  },
  data() {
    return {
      number: 0,
      noticeTypeList: [],
      //content
      noticeInfoList: [],
      nowPage:1,//当前页
      total:0,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      queryAllNotificationType().then(res=> {
        this.noticeTypeList = res.data.list;
        if(this.$route.query.index) {
          this.change(this.$route.query.index)
        } else {
          this.change(0);
        }
      })
    },
    change(index) {
      this.number = index;
      let param = {
        isPublish: "Y",
        typeId: this.noticeTypeList[index].id,
        nowPage: this.nowPage,
        pageSize: 5,
        title: ""
      }
      queryNotificationByConditions(param).then(res=> {
        // console.log('-----------------------------------');
        // console.log(res);
        this.noticeInfoList = res.data.list;
        this.total = res.data.total;
      })
    },
    //进入公告详情页
    enterNoticeDetail(item) {
      this.$router.push({
        path: '/noticeInfo/noticeDetail',
        query: {
            item: JSON.stringify(item)
        }
      });
    },
    //当前页变化
    handleCurrentChange(val) {
      this.nowPage = val;
      this.change();
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
  .main {
    margin-top: 80px;
    .sidebar {
      width: 80%;
      height: 1200px;
      color: #4F4F4F;
      border-right: 1px solid #E5E5E5;
      .sidebar_title {
          height: 79px;
          border-bottom: 1px solid #E5E5E5;
          text-align: center;
          line-height: 79px;
      }
      .sidebar_item {
        height: 47px;
        font-size: 14px;
        text-align: center;
        line-height: 47px;
      }
      .active {
        background-color: #F8F9FF;
        color: #537EEE;
        border-right: 4px solid #537EEE;
      }
      .sidebar_item:hover {
        cursor: pointer;
        background-color: #F8F9FF;
        color: #537EEE;
      }
    }
    .content {
      margin-top: 20px;
      border: 1px solid #E5E5E5;
      .banner {
        height: 54px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .con_main {
        padding: 0 80px;
        .notice_item {
          display: flex;
          align-items: center;
          height: 230px;
          border-bottom: 1px solid #E5E5E5;
          .item_left {
            float: left;
            width: 80%;
            .item_title {
                margin-bottom: 10px;
                font-size: 17px;
                color: #333;
            }
            .item_content {
                font-size: 12px;
                color: #959595;
                line-height: 20px;
            }
          }
          .item_left:hover {
            cursor: pointer;
            .item_title {
              color: #5984EC;
            }
            .item_content {
              color: #6C6C6C;
            }
          }
          .item_right {
            float: right;
            width: 20%;
            text-align: right;
            .date {
              font-size: 30px;
              color: #515151;
            }
            .dash {
              font-size: 18px;
              font-weight: 500;
              color: rgba(87, 131, 238, 1);
            }
            .year {
              font-size: 12px;
              color: #959595;
            }
          }
        }
      }
      .pagination {
        margin: 100px 0;
        text-align: center;
      }
    }
  }
</style>